<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeType' | translate }}</label>
    <select appSelect formControlName="chargeType" [collection]="chargeTypeOptions">
    </select>
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeTypeId' | translate }}</label>
    <input appInput formControlName="chargeTypeId"
           placeholder="{{ 'chargeInformation.form.enterChargeTypeId' | translate }}">
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.party' | translate }}</label>
    <select appSelect formControlName="owner" [collection]="ownerCollection">
    </select>
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.start' | translate }}</label>
    <input type="date" appInput formControlName="start">
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.end' | translate }}</label>
    <input type="date" appInput formControlName="end">
  </app-input-group>
</form>
